/*
* 加法函数，用来得到精确的加法结果
* 说明：javascript的加法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的加法结果。
* 调用：accAdd(arg1,arg2)
* 返回值：arg1加上arg2的精确结果
*/
function precisionAdd(arg1: string | number, arg2: string | number) {
    if (arg1 === null && arg2 === null) {
        return null;
    }
    if (arg1 === null || arg2 === null) {
        return arg1 || arg2;
    }
    if (isNaN(Number(arg1)) || isNaN(Number(arg2))) {
        return '';
    }
    let arg1Length, arg2Length, m, c, arg1Num, arg2Num;
    try {
        arg1Length = arg1.toString().split(".")[1].length;
    }
    catch (e) {
        arg1Length = 0;
    }
    try {
        arg2Length = arg2.toString().split(".")[1].length;
    }
    catch (e) {
        arg2Length = 0;
    }
    c = Math.abs(arg1Length - arg2Length);
    m = Math.pow(10, Math.max(arg1Length, arg2Length));
    if (c > 0) {
        const cm = Math.pow(10, c);
        if (arg1Length > arg2Length) {
            arg1Num = Number(arg1.toString().replace(".", ""));
            arg2Num = Number(arg2.toString().replace(".", "")) * cm;
        } else {
            arg1Num = Number(arg1.toString().replace(".", "")) * cm;
            arg2Num = Number(arg2.toString().replace(".", ""));
        }
    } else {
        arg1Num = Number(arg1.toString().replace(".", ""));
        arg2Num = Number(arg2.toString().replace(".", ""));
    }
    return (arg1Num + arg2Num) / m;
}

/**
 * 减法
 * @param arg1 
 * @param arg2 
 * @returns 
 */
function precisionSub(arg1: number, arg2: number) {
    let r1, r2, m, n;
    if (isNaN(arg2)) {
        return 0;
    }
    if (isNaN(arg1)) {
        return 0;
    }
    try {
        r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2));
    n = (r1 >= r2) ? r1 : r2;
    return (arg1 * m - arg2 * m) / m;
}

/**
 * 把错误的数据转正
 * strip(0.09999999999999998)=0.1
 */
function strip(num: number, precision: number = 15): number {
    return +parseFloat(Number(num).toPrecision(precision));
}

function digitLength(num: number): number {
    const eSplit = num.toString().split(/[eE]/);
    const len = (eSplit[0].split('.')[1] || '').length - +(eSplit[1] || 0);
    return len > 0 ? len : 0;
}

function float2Fixed(num: number): number {
    if (num.toString().indexOf('e') === -1) {
        return Number(num.toString().replace('.', ''));
    }
    const dLen = digitLength(num);
    return dLen > 0 ? strip(Number(num) * Math.pow(10, dLen)) : Number(num);
}

/**
 * 乘法
 * @param arg1 
 * @param arg2 
 * @returns 
 */
function precisionMul(arg1: number, arg2: number) {
    const num1Changed = float2Fixed(arg1);
    const num2Changed = float2Fixed(arg2);
    const baseNum = digitLength(arg1) + digitLength(arg2);
    const leftValue = num1Changed * num2Changed;
    return leftValue / Math.pow(10, baseNum);
}

/**
 * 除法
 * @param arg1 
 * @param arg2 
 * @returns 
 */
function precisionDiv(arg1: number, arg2: number) {
    var t1 = 0, t2 = 0, r1, r2;
    if (isNaN(arg2)) {
        return 0;
    }
    if (isNaN(arg1)) {
        return 0;
    }
    if (arg2 <= 0) {
        return 0;
    }
    try {
        t1 = arg1.toString().split(".")[1].length
    } catch (e) {
    }
    try {
        t2 = arg2.toString().split(".")[1].length
    } catch (e) {
    }
    r1 = Number(arg1.toString().replace(".", ""))
    r2 = Number(arg2.toString().replace(".", ""))
    return precisionMul((r1 / r2), Math.pow(10, t2 - t1));
}

export default {
    precisionAdd,
    precisionMul,
    precisionSub,
    precisionDiv,
}


// WEBPACK FOOTER //
// ./src/utils/Doc/Calculate.ts